import { createApp } from 'vue'
import { isDesktop } from '~/js/templates/index/helpers'

const CLASS_NAME = 'js-indexCategory'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME)
  if (!elements.length) return

  Array.from(elements).forEach((element) => {
    const {
      categoryCount,
      rowsPc,
      columnsPc,
      fontSizePc,
      rowsSp,
      columnsSp,
      fontSizeSp,
    } = element.dataset
    const rows = isDesktop() ? rowsPc : rowsSp
    const columns = isDesktop() ? columnsPc : columnsSp

    createApp({
      name: 'SectionsIndexCategory',
      data() {
        return {
          columns,
          isOpen: false,
          showButtonShowMore: categoryCount > rows * columns,
        }
      },
      computed: {
        styleFontSize() {
          return { fontSize: `${isDesktop() ? fontSizePc : fontSizeSp}px` }
        },
        textButton() {
          return this.isOpen ? '折りたたむ' : 'もっと見る'
        },
      },
      methods: {
        isShow(index) {
          return this.isOpen || index < rows * columns
        },
      },
    }).mount(element)
  })
})
